// digits: accepted phone number digit lengths (without country code)
export const COUNTRIES = [
  { name: "Afghanistan",           code: "+93",  digits: [9] },
  { name: "Albania",               code: "+355", digits: [9] },
  { name: "Algeria",               code: "+213", digits: [9] },
  { name: "Argentina",             code: "+54",  digits: [10] },
  { name: "Australia",             code: "+61",  digits: [9] },
  { name: "Austria",               code: "+43",  digits: [10, 11] },
  { name: "Bahrain",               code: "+973", digits: [8] },
  { name: "Bangladesh",            code: "+880", digits: [10] },
  { name: "Belgium",               code: "+32",  digits: [9] },
  { name: "Brazil",                code: "+55",  digits: [10, 11] },
  { name: "Cambodia",              code: "+855", digits: [8, 9] },
  { name: "Canada",                code: "+1",   digits: [10] },
  { name: "Chile",                 code: "+56",  digits: [9] },
  { name: "China",                 code: "+86",  digits: [11] },
  { name: "Colombia",              code: "+57",  digits: [10] },
  { name: "Czech Republic",        code: "+420", digits: [9] },
  { name: "Denmark",               code: "+45",  digits: [8] },
  { name: "Egypt",                 code: "+20",  digits: [10] },
  { name: "Ethiopia",              code: "+251", digits: [9] },
  { name: "Finland",               code: "+358", digits: [9, 10] },
  { name: "France",                code: "+33",  digits: [9] },
  { name: "Germany",               code: "+49",  digits: [10, 11] },
  { name: "Ghana",                 code: "+233", digits: [9] },
  { name: "Greece",                code: "+30",  digits: [10] },
  { name: "Hong Kong",             code: "+852", digits: [8] },
  { name: "Hungary",               code: "+36",  digits: [9] },
  { name: "India",                 code: "+91",  digits: [10] },
  { name: "Indonesia",             code: "+62",  digits: [9, 10, 11, 12] },
  { name: "Iran",                  code: "+98",  digits: [10] },
  { name: "Iraq",                  code: "+964", digits: [10] },
  { name: "Ireland",               code: "+353", digits: [9] },
  { name: "Israel",                code: "+972", digits: [9] },
  { name: "Italy",                 code: "+39",  digits: [9, 10] },
  { name: "Japan",                 code: "+81",  digits: [10, 11] },
  { name: "Jordan",                code: "+962", digits: [9] },
  { name: "Kenya",                 code: "+254", digits: [9] },
  { name: "Kuwait",                code: "+965", digits: [8] },
  { name: "Lebanon",               code: "+961", digits: [8] },
  { name: "Libya",                 code: "+218", digits: [9] },
  { name: "Malaysia",              code: "+60",  digits: [9, 10] },
  { name: "Mexico",                code: "+52",  digits: [10] },
  { name: "Morocco",               code: "+212", digits: [9] },
  { name: "Myanmar",               code: "+95",  digits: [8, 9, 10] },
  { name: "Nepal",                 code: "+977", digits: [10] },
  { name: "Netherlands",           code: "+31",  digits: [9] },
  { name: "New Zealand",           code: "+64",  digits: [9] },
  { name: "Nigeria",               code: "+234", digits: [10] },
  { name: "Norway",                code: "+47",  digits: [8] },
  { name: "Oman",                  code: "+968", digits: [8] },
  { name: "Pakistan",              code: "+92",  digits: [10] },
  { name: "Philippines",           code: "+63",  digits: [10] },
  { name: "Poland",                code: "+48",  digits: [9] },
  { name: "Portugal",              code: "+351", digits: [9] },
  { name: "Qatar",                 code: "+974", digits: [8] },
  { name: "Romania",               code: "+40",  digits: [9] },
  { name: "Russia",                code: "+7",   digits: [10] },
  { name: "Saudi Arabia",          code: "+966", digits: [9] },
  { name: "Singapore",             code: "+65",  digits: [8] },
  { name: "South Africa",          code: "+27",  digits: [9] },
  { name: "South Korea",           code: "+82",  digits: [9, 10] },
  { name: "Spain",                 code: "+34",  digits: [9] },
  { name: "Sri Lanka",             code: "+94",  digits: [9] },
  { name: "Sweden",                code: "+46",  digits: [9] },
  { name: "Switzerland",           code: "+41",  digits: [9] },
  { name: "Taiwan",                code: "+886", digits: [9] },
  { name: "Tanzania",              code: "+255", digits: [9] },
  { name: "Thailand",              code: "+66",  digits: [9] },
  { name: "Tunisia",               code: "+216", digits: [8] },
  { name: "Turkey",                code: "+90",  digits: [10] },
  { name: "Uganda",                code: "+256", digits: [9] },
  { name: "Ukraine",               code: "+380", digits: [9] },
  { name: "United Arab Emirates",  code: "+971", digits: [9] },
  { name: "United Kingdom",        code: "+44",  digits: [10] },
  { name: "United States",         code: "+1",   digits: [10] },
  { name: "Vietnam",               code: "+84",  digits: [9, 10] },
  { name: "Yemen",                 code: "+967", digits: [9] },
  { name: "Zimbabwe",              code: "+263", digits: [9] },
];
